import * as React from "react";
import {resourcesHelper} from "@falcon/services";
import HowToVideoModal from "./HowToVideoModal";
import {v4 as uuid} from "uuid";

interface IHowToVideoContent {
    title: string,
    description: React.ReactNode,
    videoUrl: string
}

// This widget is only intended to be used for Britannia
export default function HowToVideoCollection(): React.ReactNode {
    const [popup, setPopup] = React.useState<{title: string, videoUrl: string} | undefined>(undefined);

    if (!resourcesHelper.HOW_TO_VIDEOS) {
        throw new Error(`Unsupported use of widget for brand ${resourcesHelper.THEME}`);
    }

    function getBrandName(): string {
        return "Britannia";
    }

    function getContentArray(): IHowToVideoContent[] {
        return [
            {
                title: "How to replace your car",
                description: (
                    <>
                        New car registration not recognised?<br/>
                        Here's how to enter the details of your new car manually.
                    </>
                ),
                videoUrl: resourcesHelper.HOW_TO_VIDEOS!.REPLACE_CAR
            },
            {
                title: "How to add a driver to your policy",
                description: (
                    <>
                        Want to add a named driver?<br/>
                        No problem, let's show you how.
                    </>
                ),
                videoUrl: resourcesHelper.HOW_TO_VIDEOS!.ADD_DRIVER
            },
            {
                title: "How to change your car number plate",
                description: <>We've already got your car details so you just need to tell us the new registration.</>,
                videoUrl: resourcesHelper.HOW_TO_VIDEOS!.CHANGE_NUMBER_PLATE
            }
        ];
    }

    return (
        <>
            <h2 className="font-weight-medium margin-bottom-16">How-to videos</h2>
            <p>
                Need help making changes in your {getBrandName()} account?<br/>
                Our handy videos show you how to make all sorts of changes to your policy yourself. With step-by-step
                instructions, trust us to keep online car insurance simple.
            </p>
            <div className="how-to-video-collection">
                {getContentArray().map(({title, description, videoUrl}: IHowToVideoContent) => (
                    <div className="how-to-video-card" key={`card-${uuid()}`}>
                        <h3 className="font-weight-bold">{title}</h3>
                        <p>{description}</p>
                        <button className="btn btn-white" onClick={() => setPopup({title, videoUrl})}>
                            Watch video
                        </button>
                    </div>
                ))}
            </div>
            {popup && <HowToVideoModal {...popup} onClose={() => setPopup(undefined)}/>}
        </>
    );
}
